const LONG_TERM_KEY = 'cao_oi_long_term_facts_v3';
const SESSION_LOG_KEY = 'cao_oi_session_log_v2';
const DOC_INDEX_KEY = 'cao_oi_workspace_doc_index_v2';

export const MOM_LEARNING_REPO_PATH =
  '/Users/gaothecow/Downloads/📁 Tài Liệu Học Tập Của Mẹ (Mom_s Learning Materials)';

export const MASTER_DOSSIER_PATH =
  '/Users/gaothecow/Downloads/mai_quyen_master_profile_and_business_dossier.md';

export interface WorkspaceContextSnapshot {
  activeDocTitle: string;
  activeDocCleanText: string;
  selectedText: string;
  relatedDocsSummary: string;
  longTermMemory: string[];
  recentSessionLog: string[];
}

export const DEFAULT_LONG_TERM_FACTS: string[] = [
  'HỌC VIÊN & CHỦ NHÂN WORKSPACE: Chị Mai Quyên. Khi trò chuyện bằng tiếng Việt, Chị xưng là "tớ" và gọi trợ lý AI là "Cáo". Trợ lý Cáo xưng hô ấm áp, tôn trọng, tinh tế như một người bạn đồng hành đáng tin cậy ("Chị Quyên", "Chị").',
  'ĐỊA DANH & ĐỜI SỐNG: Hội An, Việt Nam. Mẹ của 2 con trai; bố mẹ đẻ (ông bà ngoại Gạo) thường ở cùng gia đình. Chăm sóc vườn nhà và hồ cá (cây thủy sinh, hoa phong lữ hoa hồng rosebud geranium, giàn chanh dây), đàn piano, đan móc len (áo gile cổ V không tay, khăn vuông họa tiết mèo, mẫu Sabai Top), đạp xe đường dài, nhiếp ảnh màu phim cổ điển (Dazz Cam).',
  '5 GIÁ TRỊ CỐT LÕI (5 GUIDING PILLARS): Empathy (Thấu cảm), Mindful (Tỉnh thức/Chánh niệm), Simplicity (Giản đơn), Harmony (Hài hòa), Complexity (Sự phức hợp chiều sâu).',
  'DOANH NGHIỆP XÃ HỘI REACHING OUT VIETNAM (Thành lập năm 2000 tại 131 Trần Phú, Phố cổ Hội An): Tạo việc làm hòa nhập, đào tạo nghề và trao quyền cho người điếc, khiếm thính và người khuyết tật.',
  'REACHING OUT TEA HOUSE: Nổi tiếng toàn cầu với triết lý "The Beauty of Silence" (Vẻ đẹp của sự tĩnh lặng — không Wi-Fi, không tiếng ồn, kiến trúc nhà gỗ cổ và sân trong). Khách giao tiếp với nhân viên khiếm thính bằng phiếu gọi món viết tay và các khối gỗ thủ công ("Hot Water", "Ice", "Bill", "Thank You"). Phục vụ trà đặc sản (Trà Sen, Trà Lài, Ô Long), Set thử trà (Tea Tasting Set), cà phê phin truyền thống, Cold Brew, Yuzu Cold Brew, Set thử cà phê (Coffee Tasting Set), đĩa bánh quy thủ công.',
  'REACHING OUT ARTS & CRAFTS: Xưởng chế tác và phòng trưng bày thủ công mỹ nghệ cao cấp: trang sức bạc thủ công (đặc biệt họa tiết chiếc lá bạc), ấm chén gốm sứ thủ công, đồ vải lanh/lụa thêu tay và mộc mỹ nghệ.',
  'CÁC DỰ ÁN 2026 TIÊU BIỂU: Chương trình thực tập 10 ngày cho Kokoro Yasuda (Đại học Hosei, Nhật Bản); phim tài liệu ngắn với nữ sinh viên điện ảnh Saki Hiraoka (Nhật Bản); dự án Bơ đậu phộng nghiền cối đá thủ công mẻ nhỏ (100% đậu phộng rang thuần chất).',
  'CHỨNG CHỈ QUỐC TẾ HOÀN THÀNH: Google Project Management (Coursera - Tháng 5/2026), Google Digital Marketing & E-commerce (Coursera - Tháng 4/2026), Google AI Essentials (Tháng 11/2025), Gemini Academy 2026.',
  'KHO TÀI LIỆU HỌC TẬP CỦA MẸ (LOCAL PATH): /Users/gaothecow/Downloads/📁 Tài Liệu Học Tập Của Mẹ (Mom_s Learning Materials) — Cáo luôn chủ động đối chiếu và dẫn nguồn thư mục chính xác.',
  'THƯ MỤC 00_Tong_Hop_Va_Huong_Dan: MASTER_BUSINESS_MANAGEMENT_PLAYBOOK.md (Sổ tay quản trị kinh doanh toàn diện 8 chương), HUONG_DAN_CHI_TIET.md.',
  'THƯ MỤC 01_Lanh_Dao_Va_Quan_Tri_CEO: Sale Management CEO05 10.2026, CEO Communication 09.2026, Situational Leadership II (SLII: D1->S1, D2->S2, D3->S3, D4->S4), 8 CEO Archetypes (Steve Tappin), Từ điển 42 Năng lực Harvard, Kỷ luật Thực thi Chiến lược (Strategy Execution).',
  'THƯ MỤC 02_Khai_Van_Co_Van_Va_Nhan_Su: Kỹ thuật Khai vấn Hiệu suất Push & Pull (6 case thực hành), Mentoring Conversation (5 case), Cuộc trò chuyện Tạo động lực & Ma trận 4A (Attention, Appreciation, Autonomy, Achievement - 4 case), Phản hồi chuẩn FACT Feedback (Fact - Action - Consequence - Target), Xây dựng khung lương thưởng & khảo sát gắn kết.',
  'THƯ MỤC 03_Quan_Ly_Du_An_Coursera: Chứng chỉ Google Project Management, Bộ thuật ngữ PM (PM Terms & Definitions), Mục tiêu SMART, Tổng kết kiến thức Mô-đun 3 (Hỏi đáp cùng AI).',
  'THƯ MỤC 04_Tai_Chinh_Va_Ke_Toan_Quan_Tri: Giáo trình Kế toán Quản trị cho Lãnh đạo, Phân tích C-V-P (Chi phí - Sản lượng - Lợi nhuận), Điểm hòa vốn (Break-even Point), Số dư đảm phí (Contribution Margin), Định mức tỷ lệ chi phí & kiểm soát nội bộ.',
  'THƯ MỤC 05_Branding_Marketing_Va_AI: Cẩm nang Chiến lược Branding Thực tiễn, 365 Storyselling Prompts & Storytelling Hooks, Cẩm nang Bỏ túi Hướng dẫn Sử dụng AI cho Reaching Out, Workbook Nghệ thuật Chuyển hóa Niềm tin bằng Ngôn từ, Marketing 4P-mix.',
  'THƯ MỤC 06_Nghe_Thuat_Lam_Banh_Va_FB: Trọn bộ công thức Bánh Madeleine (Madeleine Chanh dây tươi, Madeleine Gluten-free, Madeleine Cổ điển Pháp chuẩn Agnes Devereux), Giáo trình Vận hành F&B, Sổ tay The Restaurant Entrepreneur & Vận hành Espresso.',
  'THƯ MỤC 07_Thu_Cong_Dan_Moc: Bộ hướng dẫn và sơ đồ đan mẫu áo Sabai Top No. 1 & No. 2 (huong_dan_dan_sabai_top_no2.pdf, SABAI_Top_No2_Pattern.docx).',
  'THƯ MỤC 08_Giao_Tiep_Va_Ho_Tro_Nguoi_Khiem_Thinh: Sổ tay hướng dẫn hỗ trợ người khiếm thính ở bệnh viện, Lớp kỹ năng giao tiếp với người khiếm thính Bài 2, Kế hoạch Mentoring & Hỗ trợ thực tập sinh Kokoro Yasuda.',
  'NGUYÊN TẮC BẤT DI BẤT DỊCH VỀ CHẤT TẠO NỞ: "Bột nở" là Baking Powder. "Muối nở" là Baking Soda. Tuyệt đối không bao giờ nhầm lẫn, dịch nhầm hoặc đánh tráo.',
  'NGUYÊN TẮC BẤT DI BẤT DỊCH VỀ BÁNH MADELEINE: Luôn nướng 2 giai đoạn nhiệt chuẩn xác: 4 phút ở 200°C, sau đó hạ ngay xuống 160°C nướng 7 phút (Tổng thời gian 11 phút).',
  'NGUYÊN TẮC BẤT DI BẤT DỊCH VỀ XÔI BÁNH DÀY HỘI AN: Chỉ ăn kèm đậu xanh cắt vuông và mè chưa bóc vỏ rang giã. TUYỆT ĐỐI KHÔNG ăn kèm chả quế, pâté hay mỡ hành.',
  'KỸ THUẬT LÀM BÁNH & CÀ PHÊ NÂNG CAO: Tự rang cà phê mẻ nhỏ bằng máy rang trống thủy tinh (glass drum roaster), quan sát First Crack; pha phin truyền thống và Yuzu Cold Brew; bánh mì Sourdough men tự nhiên, Canelé de Bordeaux (ủ lạnh 24-48h), Financiers (bơ nâu beurre noisette + bột hạnh nhân), Melonpan, Scones, bánh mì Mochi dẻo, bánh chay thực vật (vegan cake) trang trí thảo mộc vườn nhà.',
];

// 1. EXTRACT 100% CLEAN TEXT FROM BLOCKSUITE (No Sidebar/Button Garbage)
export function extractCleanBlockSuiteContext(): { title: string; content: string } {
  try {
    if (typeof document !== 'undefined') {
      const editorHost = document.querySelector('editor-host') as any;
      const doc = editorHost?.doc;

      if (doc) {
        const lines: string[] = [];
        const pageBlock = doc.getBlocksByFlavour ? doc.getBlocksByFlavour('affine:page')[0] : null;
        const docTitle = pageBlock?.title?.toString() || 'Bài giảng hiện tại';

        const allBlocks = doc.getBlocks ? doc.getBlocks() : [];
        for (const block of allBlocks) {
          const text = block.model?.text?.toString()?.trim();
          if (!text) continue;

          if (block.flavour === 'affine:paragraph') {
            const type = block.model?.type || 'text';
            const prefix = type.startsWith('h') ? '#'.repeat(Number(type[1]) || 1) + ' ' : '';
            lines.push(`${prefix}${text}`);
          } else if (block.flavour === 'affine:list') {
            lines.push(`• ${text}`);
          } else {
            lines.push(text);
          }
        }

        const cleanContent = lines.join('\n').slice(0, 14000);
        if (cleanContent.length > 10) {
          indexDocInBackground(doc.id, docTitle, cleanContent);
          return { title: docTitle, content: cleanContent };
        }
      }
    }
  } catch (e) {
    console.warn('[CaoOi Context] Fallback to clean DOM selector:', e);
  }

  // Fallback: Only scrape inside the editor container, NEVER the sidebar or modals
  if (typeof document !== 'undefined') {
    const editorContainer =
      document.querySelector('.affine-page-viewport') ||
      document.querySelector('.affine-edgeless-viewport') ||
      document.querySelector('editor-host');

    const rawText = (editorContainer as HTMLElement)?.innerText || '';
    return {
      title: document.title || 'Trang hiện tại',
      content: rawText.slice(0, 12000),
    };
  }

  return {
    title: 'Trang hiện tại',
    content: '',
  };
}

// 2. INDEX EVERY DOC MOM OPENS SO AI REMEMBERS OTHER PAGES IN THE WORKSPACE
function indexDocInBackground(docId: string, title: string, content: string) {
  try {
    if (typeof window === 'undefined') return;
    const index: Record<string, { title: string; snippet: string; updatedAt: number }> =
      JSON.parse(localStorage.getItem(DOC_INDEX_KEY) || '{}');

    index[docId] = {
      title,
      snippet: content.slice(0, 600).replace(/\n+/g, ' '),
      updatedAt: Date.now(),
    };
    localStorage.setItem(DOC_INDEX_KEY, JSON.stringify(index));
  } catch {}
}

export function getRelatedWorkspaceDocs(_query: string, currentTitle: string): string {
  try {
    if (typeof window === 'undefined') return '';
    const index: Record<string, { title: string; snippet: string; updatedAt: number }> =
      JSON.parse(localStorage.getItem(DOC_INDEX_KEY) || '{}');

    const entries = Object.values(index)
      .filter((d) => d.title !== currentTitle)
      .sort((a, b) => b.updatedAt - a.updatedAt)
      .slice(0, 5);

    if (entries.length === 0) return 'Chưa có trang liên quan khác.';
    return entries.map((e) => `- [${e.title}]: ${e.snippet}`).join('\n');
  } catch {
    return '';
  }
}

// 3. TWO-TIER PERSISTENT MEMORY (Never Loses Early Lecture Points)
export function getLongTermFacts(): string[] {
  try {
    if (typeof window !== 'undefined') {
      const saved = JSON.parse(localStorage.getItem(LONG_TERM_KEY) || '[]');
      if (Array.isArray(saved) && saved.length > 5) return saved;
    }
  } catch {}

  return DEFAULT_LONG_TERM_FACTS;
}

export function addLongTermFact(fact: string) {
  const clean = fact.trim();
  if (!clean || clean.length < 10) return;
  const current = getLongTermFacts();
  if (!current.includes(clean)) {
    const updated = [...current.slice(-50), clean];
    if (typeof window !== 'undefined') {
      localStorage.setItem(LONG_TERM_KEY, JSON.stringify(updated));
    }
  }
}

export function getSessionMemory(): string[] {
  try {
    if (typeof window !== 'undefined') {
      return JSON.parse(localStorage.getItem(SESSION_LOG_KEY) || '[]');
    }
    return [];
  } catch {
    return [];
  }
}

export function appendSmartMemory(entry: string, isImportantFact = false) {
  // Strip any accidental <think> or meta tags before saving
  const cleaned = entry
    .replace(/<think>[\s\S]*?<\/think>/gi, '')
    .replace(/^(Planning|Thinking|The user asks).*$/gim, '')
    .trim();

  if (!cleaned) return;

  const timestamp = new Date().toLocaleTimeString('vi-VN', {
    hour: '2-digit',
    minute: '2-digit',
  });

  if (isImportantFact) {
    addLongTermFact(`[${timestamp}] ${cleaned}`);
  }

  const session = getSessionMemory();
  // If session log exceeds 30 entries, roll the oldest 10 into a single compressed milestone
  if (session.length >= 30) {
    const oldestTen = session.slice(0, 10).join(' | ');
    const compressed = `📌 [Tóm tắt phần đầu buổi học]: ${oldestTen.slice(0, 500)}...`;
    const nextSession = [compressed, ...session.slice(10), `[${timestamp}] ${cleaned}`];
    if (typeof window !== 'undefined') {
      localStorage.setItem(SESSION_LOG_KEY, JSON.stringify(nextSession));
    }
  } else {
    if (typeof window !== 'undefined') {
      localStorage.setItem(
        SESSION_LOG_KEY,
        JSON.stringify([...session, `[${timestamp}] ${cleaned}`])
      );
    }
  }
}

// 4. MASTER CONTEXT BUILDER FOR EVERY AI CALL
export function buildPerfectPromptContext(userPrompt: string, explicitSelection = ''): string {
  const { title, content } = extractCleanBlockSuiteContext();
  const selection =
    explicitSelection ||
    (typeof window !== 'undefined' ? window.getSelection()?.toString()?.trim() : '') ||
    '';
  const relatedDocs = getRelatedWorkspaceDocs(userPrompt, title);
  const longTerm = getLongTermFacts().join('\n');
  const sessionLog = getSessionMemory().slice(-15).join('\n');

  return `
=== HỒ SƠ & BỘ NHỚ DÀI HẠN (LONG-TERM MEMORY) ===
${longTerm}

=== 📁 THƯ MỤC TÀI LIỆU HỌC TẬP CỦA MẸ (LOCAL REPOSITORY PATH & INDEX) ===
Đường dẫn cục bộ: ${MOM_LEARNING_REPO_PATH}
(Cáo luôn chủ động trích dẫn và đối chiếu chính xác thư mục và tài liệu tương ứng bên dưới khi giải đáp cho Chị Quyên)
- 00_Tong_Hop_Va_Huong_Dan: MASTER_BUSINESS_MANAGEMENT_PLAYBOOK.md (8 chương quản trị toàn diện)
- 01_Lanh_Dao_Va_Quan_Tri_CEO: Sale Management CEO05, CEO communication, Situational Leadership II, 8 CEO Archetypes, Harvard 42 Competencies
- 02_Khai_Van_Co_Van_Va_Nhan_Su: Push & Pull Coaching (6 cases), Mentoring (5 cases), Motivation 4A (4 cases), FACT Feedback (Handout 03a/03b)
- 03_Quan_Ly_Du_An_Coursera: Google Project Management, Mục tiêu SMART, PM Glossary
- 04_Tai_Chinh_Va_Ke_Toan_Quan_Tri: Kế toán Quản trị cho Lãnh đạo, Phân tích C-V-P & Điểm hòa vốn, Thông tin thích hợp
- 05_Branding_Marketing_Va_AI: Cẩm nang Branding, 365 Storyselling Prompts & Hooks, Cẩm nang AI Reaching Out
- 06_Nghe_Thuat_Lam_Banh_Va_FB: Madeleines (Chanh dây, Gluten-free, Classic Agnes Devereux), Bánh Nhật, Vận hành F&B
- 07_Thu_Cong_Dan_Moc: Sabai Top Pattern No. 1 & No. 2
- 08_Giao_Tiep_Va_Ho_Tro_Nguoi_Khiem_Thinh: Sổ tay hỗ trợ người khiếm thính ở bệnh viện, Kế hoạch đào tạo thực tập sinh Kokoro Yasuda

=== DIỄN BIẾN & GHI ÂM GẦN ĐÂY TRONG BUỔI HỌC ===
${sessionLog || 'Mới bắt đầu phiên làm việc.'}

=== CÁC TRANG TÀI LIỆU KHÁC TRONG WORKSPACE ===
${relatedDocs}

=== NỘI DUNG TRANG / BẢNG VẼ ĐANG MỞ: "${title}" ===
${content || '(Trang hiện tại đang trống)'}

${selection ? `=== ĐOẠN VĂN BẢN ĐANG CHỌN (ƯU TIÊN SỐ 1) ===\n"${selection}"\n` : ''}
`.trim();
}
